/*
 * fonctions spécifiques au formulaire d'action
 */

/*
 * validation du formulaire action
 */ 
$(document).on('click', '#frm_action button[name="action"]', function(e) {
	e.preventDefault();

	var $this = $(this);
	var $frm = $($this.parents('form')[0]);

	var valid = true;

	if( $frm[0].checkValidity() === false )
		valid = false;

	$frm.addClass('was-validated');
	fixBootstrapSelectValidation();

	if( !valid ) {
		if( $('.form-group *:invalid', $frm).get().length ) {
			// si pas de champ invalide visible -> on change la langue pour le premier champ invalide invisible
			if( !$('.form-group *:invalid:visible', $frm).get().length ) {
				$('.lang_selector .btn[data-lang="' + $($('.form-group *:invalid:hidden', $frm).parents('.form-group')).data('lang') + '"]').click();
			}
			//on scrolle jusqu'au premier champ invalide
			var pos = $($('.form-group *:invalid:visible:eq(0)', $frm).parents('.form-group')[0]).offset().top;
			var pos2 = $($('.form-group *:invalid:visible:eq(0)', $frm).parents('form')[0]).offset().top;
			$('.fancybox-container.fancybox-is-open .fancybox-slide--current').animate({scrollTop: pos - pos2 }, 10);
			$('.form-group *:invalid:visible:eq(0)', $frm).focus();
		}
	}
	else {
		$.ajax({
			type: "POST",
			url: $frm.attr('action'),
			dataType: 'json',
			data: $frm.serialize() + '&action=' + $this.val()
		}).done(function(data) {
			if( data.success ) {

				// si origine programme
				if( data.origine == 'programme' || data.origine == 'programme_lot' ) {
					$.fancybox.getInstance().setContent( $.fancybox.getInstance().current, data.content );
					$('#lots_list').html(data.lotslist);
				}
				// si origine stock
				else if( data.origine == 'stock' || data.origine == 'stock_lot' ) {
					$.fancybox.getInstance().setContent( $.fancybox.getInstance().current, data.content );
					$('#main').html(data.stock);
				}
				// si origine redirect
				else if( data.origine == 'redirect' && data.url ) {
					location.href = data.url;
				}
			}
			else {
				$.fancybox.getInstance().setContent( $.fancybox.getInstance().current, data.content );
			}
		});
	}
});


/*
 * toggle new_client
 */
$(document).on('show.bs.collapse', '#zone_new_client', function() {
	$('#frm_action_new_client').prop('checked', true);
	$('#frm_action_nom').prop('required', true);
	$('#frm_action_prenom').prop('required', true);
});
$(document).on('hide.bs.collapse', '#zone_new_client', function() {
	$('#frm_action_new_client').prop('checked', false);
	$('#frm_action_nom').prop('required', false);
	$('#frm_action_prenom').prop('required', false);
});


/*
 * si action livraison on affiche le champ date de livraison
 */
 $(document).on('change', '#frm_action_type', function() {
 	if( $(this).val() == 'LIVRAISON' ) {
 		$('#zone_frm_action_livraison').removeClass('d-none');
 		$('#frm_action_date_livraison').prop('required', true);
 	}
 	else {
 		$('#zone_frm_action_livraison').addClass('d-none');
 		$('#frm_action_date_livraison').prop('required', false);
 	}
 });


/*
 * suppression action
 */
$(document).on('click', '[name="action"][value="actiondelete"][data-actiondelete][data-url]', function() {
	var $this = $(this);
	$.ajax({
		type: "POST",
		url: $this.data('url'),
		dataType: 'json',
		data: { action: 'actiondelete', actiondelete: $this.data('actiondelete') }
	}).done(function(data) {
		// si origine programme
		if( data.origine == 'programme' ) {
			$('#lots_list').html(data.lotslist);
		}
		// si origine programme_lot
		else if( data.origine == 'programme_lot' ) {
			$.fancybox.getInstance().setContent( $.fancybox.getInstance().current, data.content );
			$('#lots_list').html(data.lotslist);
		}	
		// si origine stock
		else if( data.origine == 'stock' ) {
			$('#main').html(data.stock);
			if( sessionStorage.stock_tab ) {
				$('#' + sessionStorage.stock_tab).tab('show');
			}
			else {
				$('#stock a[data-toggle="pill"]:eq(0)').tab('show');
			}
		}
		// si origine stock_lot
		else if( data.origine == 'stock_lot' ) {
			$.fancybox.getInstance().setContent( $.fancybox.getInstance().current, data.content );
			$('#main').html(data.stock);
			if( sessionStorage.stock_tab ) {
				$('#' + sessionStorage.stock_tab).tab('show');
			}
			else {
				$('#stock a[data-toggle="pill"]:eq(0)').tab('show');
			}
		}
	});
});


/*
 * desistement
 */
$(document).on('click', '[name="action"][value="optiondesistement"][data-optiondesistement][data-url]', function() {
	var $this = $(this);
	$.ajax({
		type: "POST",
		url: $this.data('url'),
		dataType: 'json',
		data: { action: 'optiondesistement', optiondesistement: $this.data('optiondesistement') }
	}).done(function(data) {
		// si origine programme
		if( data.origine == 'programme' ) {
			$('#lots_list').html(data.lotslist);
		}
		// si origine programme_lot
		else if( data.origine == 'programme_lot' ) {
			$.fancybox.getInstance().setContent( $.fancybox.getInstance().current, data.content );
			$('#lots_list').html(data.lotslist);
		}	
		// si origine stock
		else if( data.origine == 'stock' ) {
			$('#main').html(data.stock);
			if( sessionStorage.stock_tab ) {
				$('#' + sessionStorage.stock_tab).tab('show');
			}
			else {
				$('#stock a[data-toggle="pill"]:eq(0)').tab('show');
			}
		}
		// si origine stock_lot
		else if( data.origine == 'stock_lot' ) {
			$.fancybox.getInstance().setContent( $.fancybox.getInstance().current, data.content );
			$('#main').html(data.stock);
			if( sessionStorage.stock_tab ) {
				$('#' + sessionStorage.stock_tab).tab('show');
			}
			else {
				$('#stock a[data-toggle="pill"]:eq(0)').tab('show');
			}
		}
	});
});


/*
 * renouvellement option
 */
$(document).on('click', '[name="action"][value="optionrenouvellement"][data-optionrenouvellement][data-url]', function() {
	var $this = $(this);
	$.ajax({
		type: "POST",
		url: $this.data('url'),
		dataType: 'json',
		data: { action: 'optionrenouvellement', optionrenouvellement: $this.data('optionrenouvellement') }
	}).done(function(data) {
		// si origine programme
		if( data.origine == 'programme' ) {
			$('#lots_list').html(data.lotslist);
		}
		// si origine programme_lot
		else if( data.origine == 'programme_lot' ) {
			$.fancybox.getInstance().setContent( $.fancybox.getInstance().current, data.content );
			$('#lots_list').html(data.lotslist);
		}	
		// si origine stock
		else if( data.origine == 'stock' ) {
			$('#main').html(data.stock);
			if( sessionStorage.stock_tab ) {
				$('#' + sessionStorage.stock_tab).tab('show');
			}
			else {
				$('#stock a[data-toggle="pill"]:eq(0)').tab('show');
			}
		}
		// si origine stock_lot
		else if( data.origine == 'stock_lot' ) {
			$.fancybox.getInstance().setContent( $.fancybox.getInstance().current, data.content );
			$('#main').html(data.stock);
			if( sessionStorage.stock_tab ) {
				$('#' + sessionStorage.stock_tab).tab('show');
			}
			else {
				$('#stock a[data-toggle="pill"]:eq(0)').tab('show');
			}
		}
	});
});


/*
 * desistement
 */
$(document).on('click', '[name="action"][value="libererlot"][data-libererlot][data-url]', function() {
	var $this = $(this);
	$.ajax({
		type: "POST",
		url: $this.data('url'),
		dataType: 'json',
		data: { action: 'libererlot', libererlot: $this.data('libererlot') }
	}).done(function(data) {
		// si origine programme
		if( data.origine == 'programme' ) {
			$('#lots_list').html(data.lotslist);
		}
		// si origine programme_lot
		else if( data.origine == 'programme_lot' ) {
			$.fancybox.getInstance().setContent( $.fancybox.getInstance().current, data.content );
			$('#lots_list').html(data.lotslist);
		}	
		// si origine stock
		else if( data.origine == 'stock' ) {
			$('#main').html(data.stock);
			if( sessionStorage.stock_tab ) {
				$('#' + sessionStorage.stock_tab).tab('show');
			}
			else {
				$('#stock a[data-toggle="pill"]:eq(0)').tab('show');
			}
		}
		// si origine stock_lot
		else if( data.origine == 'stock_lot' ) {
			$.fancybox.getInstance().setContent( $.fancybox.getInstance().current, data.content );
			$('#main').html(data.stock);
			if( sessionStorage.stock_tab ) {
				$('#' + sessionStorage.stock_tab).tab('show');
			}
			else {
				$('#stock a[data-toggle="pill"]:eq(0)').tab('show');
			}
		}
	});
});